/**
 * AddCurrencyCtrl controller
 * Add/Edit Currencies
 */

import { GET_CURRENCIES } from 'app/core/constants'

/**
 * AddCurrencyCtrl controller
 *
 * @class AddCurrencyCtrl
 * @memberof mwApp/settings
 * @see mwApp/settings
 *
 * @ngdoc controller
 * @name mwApp/settings.controller:AddCurrencyCtrl
 */
/* @ngInject */
export default function AddCurrencyCtrl ($uibModalInstance, currency, existingCurrencies) {
  var vm = this

  /**
   * Currency
   *
   * @memberof mwApp/settings.controller:AddCurrencyCtrl
   * @type {models.Currency}
   */
  vm.currency = currency

  /**
   * isNew flag
   *
   * @memberof mwApp/settings.controller:AddCurrencyCtrl
   * @type {Boolean}
   */
  vm.isNew = currency._isNew()

  /**
   * Temporary object containing currency code and symbols
   *
   * @memberof mwApp/settings.controller:AddCurrencyCtrl
   * @name vm.cur
   * @type {Object}
   */

  /**
   * Map with world currencies
   *
   * @memberof mwApp/settings.controller:AddCurrencyCtrl
   * @name vm.currencies
   * @type {Object}
   */

  if (vm.isNew) {
    GET_CURRENCIES()
      .except(c => existingCurrencies.indexOf(c.code) > -1) // filter out all existing currencies
      .to(vm.currencies = [])
  } else {
    vm.currencies = [vm.cur = {
      code: currency.name,
      symbol: currency.symbol
    }]
  }

  /**
   * Create or edit currency, and close modal window afterwards
   *
   * @memberof mwApp/settings.controller:AddCurrencyCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    currency.name = vm.cur.code
    currency.symbol = vm.cur.symbol
    currency._save()
      .then(() => $uibModalInstance.close(currency))
      .finally(vm.unsetDisable)
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/settings.controller:AddCurrencyCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
